import { transition } from '@helpers/animate';
import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { h3, paragraphMedium, tag } from '@helpers/typography';
import styled, { css } from 'styled-components';
import MediaEmbed from '../Misc/MediaEmbed/MediaEmbed';
import SectionWrapperStyles from '../SectionWrapper/SectionWrapper.styles';
const Container = styled.div `
  padding-bottom: 8px;
  height: 100%;
`;
const Link = styled.span `
  color: ${brand.black};
  text-decoration: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  height: 100%;
`;
const Title = styled.h3 `
  ${h3};
  ${transition('text-decoration-color')};
  text-decoration: underline;
  text-underline-position: under;
  text-decoration-color: transparent;

  ${Link}:hover & {
    text-decoration-color: ${brand.black};
  }
`;
const ImageWrapper = styled.div `
  ${imageWrapperPreserveRatio(836, 454)};

  margin-bottom: ${fluid(14, 16)};

  ${Link}:not(:has(${Title})) & {
    margin-bottom: ${fluid(20, 26)};
  }
`;
const Image = styled.img `
  ${imageCoverContainer()};
`;
const Video = styled.video `
  ${imageCoverContainer()};
`;
const commonContent = css `
  display: block;
  margin-top: auto;
  margin-bottom: ${fluid(8, 12)};
  max-width: 275px;
  text-align: center;

  ${Link}:not(:has(${Title})) & {
    margin-top: 0;
  }

  @media ${from(Device.DesktopSmall)} {
    max-width: 650px;
    margin-bottom: 8px;
  }
`;
const SubTitle = styled.span `
  ${tag};
  ${commonContent};
`;
const Content = styled.span `
  ${paragraphMedium};
  ${commonContent};
`;
const Cta = styled.span `
  ${fonts.brandonGrotesque.medium};
  font-size: 18px;
  line-height: 1.5;
  text-decoration: none;
  text-underline-position: under;
  color: ${brand.black};
  ${transition('color')};

  ${Link}:not(:has(${Title})) & {
    margin-top: auto;
  }

  ${Container}:hover & {
    color: ${brand.green};
  }
`;
const MediaEmbedWrapper = styled(MediaEmbed) `
  margin: 0;

  ${() => SectionWrapperStyles.Inner} {
    width: 100%;
    margin: 0;
    padding: 0;
  }
`;
const SignpostCardsStyles = {
    Container,
    Content,
    Cta,
    Image,
    ImageWrapper,
    Link,
    SubTitle,
    Title,
    Video,
    MediaEmbedWrapper,
};
export default SignpostCardsStyles;
